var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 21,
    viewBox: "0 0 34 21",
    width: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h37.824394v25.016667h-37.824394z",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.924697 4.358485h9.977879v16.296818h-9.977879z",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.9524242 12.5083333c-.0025053-3.17962076 1.4571298-6.18381519 3.9583334-8.14696966-4.2491513-3.33937904-10.35110292-2.8529696-14.0175673 1.11739282s-3.66646438 10.09167014 0 14.06203254 9.768416 4.4567719 14.0175673 1.1173928c-2.5019995-1.9637779-3.9617238-4.9692175-3.9583334-8.1498485z",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f79e1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.7207576 19.5278788v-.8285714h.1666666v-.1714286h-.3966666v.1714286h.1566666v.8285714zm.77 0v-1h-.12l-.14.7142857-.14-.7142857h-.12v1h.0866666v-.7571429l.13.65h.09l.13-.65v.7571429z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.679697 12.5083333c0 3.9679429-2.2657728 7.5875206-5.8347977 9.3214846-3.569025 1.7339641-7.8148053 1.2778942-10.9341417-1.1745149 2.5001122-1.9648211 3.9598571-4.9686161 3.9598571-8.1484091 0-3.17979289-1.4597449-6.18358791-3.9598571-8.14840905 3.1193364-2.45240912 7.3651167-2.90847896 10.9341417-1.17451491 3.5690249 1.73396405 5.8347977 5.35354177 5.8347977 9.32148456z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.d7e0af27.svg";
export { ForwardRef as ReactComponent };